import { Field, Model, CodeModel, FIELD_TYPES } from "../../vue-ocom/schema";
import { LTA_NEW } from "@/app/leave_task_actions.js";
import { MANAGER_APPROVAL } from "@/app/leave_task_types.js";

export default Model("leave_request_task", {
  verbose_name: "Leave Request Task ",
  verbose_name_plural: "Leave Request Tasks",
  fields: [
    Field("id", {
      label: "ID",
      primary_key: true,
      readonly: true,
      hide: false,
      field_type: FIELD_TYPES.AutoNumber,
    }),

    Field("task_type", {
      label: "Task Type",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Number,
      default: () => {
        return MANAGER_APPROVAL;
      },
    }),
    Field("when", {
      label: "When",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      },
    }),
    Field("who", {
      label: "Who",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "Employee",
      ref_display_field: "first_name",
      default: () => {
        return null;
      },
    }),
    Field("who__first_name", {
      label: "Who",
      primary_key: false,
      readonly: true,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return null;
      },
    }),
    Field("note", {
      label: "Note",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return "";
      },
    }),
    Field("status", {
      label: "Status",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Number,
      default: () => {
        return 0;
      },
    }),
    Field("action", {
      label: "Action",
      primary_key: false,
      readonly: true,
      hide: true,
      required: false,
      field_type: FIELD_TYPES.Integer,
      default: () => {
        return LTA_NEW;
      },
    }),
    Field("created_date", {
      label: "Created Date",
      primary_key: false,
      readonly: true,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      },
    }),
    Field("modified_date", {
      label: "Modified Date",
      primary_key: false,
      readonly: true,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      },
    }),
  ],
});
